<template>
	<div>
		<div v-for="checklist in sortedChecklists" :key="checklist.id">
			<checklist-fillable
				:checklist="checklist"
				:readonly="readonly"
				v-on:deleted="removeChecklist">
			</checklist-fillable>
		</div>
	</div>
</template>

<script type="text/javascript">

import Field from "@/components/Field"
import TableList from "@/components/TableList"
import ChecklistFillable from "@/components/super_components/ChecklistFillable"

export default {
	name: "ChecklistFillableList",
	components: {
		Field,
		TableList,
		ChecklistFillable,
	},
	props: [
		"checklists",
		"readonly"
	],
	data() {
		return {

		}
	},
	watch: {

	},
	computed: {
		sortedChecklists() {
			return this.checklists.sort((a,b) => (a.created_at > b.created_at) ? 1 : -1)
		}
	},
	methods: {
		removeChecklist(checklist) {
			const index = this.checklists.findIndex(cl => cl.id == checklist.id)
			if (index > -1)
				this.checklists.splice(index, 1)
		}
	},
	mounted() {

	}
}

</script>